
import { mapActions, mapState } from 'vuex';
import loginUserMixin from '~/mixins/loginUser';
import registerUserMixin from '~/mixins/registerUser';
import submitAddressMixin from '~/mixins/submitAddress';
import wasteRemovalMixin from '~/mixins/wasteRemoval';
import fileUploadService from '~/services/fileUpload';

export default {
    name: 'WasteRemoval',
    mixins: [wasteRemovalMixin, loginUserMixin, registerUserMixin, submitAddressMixin],
    data() {
        /* eslint camelcase: 0 */
        return {
            accessInformation: '',
            date: '',
            categories: [],
            description: '',
            landType: true,
            images: [],
            services: 0,
            showUserStep: !this.$store.state.auth.loggedIn,
            size: '',
        };
    },
    head() {
        return {
            title: `${this.$t('metadata.waste_removal.title')} - ClearWaste`,
            link: [{ rel: 'canonical', href: `${this.$config.domain}${this.$route.path}` }],
            meta: [
                { hid: 'description', name: 'description', content: `${this.$t('metadata.waste_removal.description')}` },
                { hid: 'og:title', property: 'og:title', content: this.$t('metadata.waste_removal.title') },
                { hid: 'og:description', property: 'og:description', content: this.$t('metadata.waste_removal.description') },
                { hid: 'og:url', proprty: 'og:url', content: `${this.$config.domain}${this.$route.path}` },
            ],
        };
    },
    computed: {
        ...mapState(['auth']),
        title() {
            switch (this.services) {
                case 1:
                    return this.$t('waste_removal.van');
                case 2:
                    return this.$t('waste_removal.skip');
                case 3:
                    return this.$t('waste_removal.grab');
                case 4:
                    return this.$t('waste_removal.specialist');
                default:
                    return this.$t('waste_removal.long_title');
            }
        },
    },
    watch: {
        '$route.fullPath': function resetTitle() {
            // reset the service to 0 when user navigates back after selecting a servers; fixes title staying as previously select service.
            if (this.$route.fullPath === '/waste-removal' || this.$route.fullPath === '/waste-removal?step=service') {
                this.services = 0;
            }
        },
    },
    created() {
        this.$form.addValidations({
            ...this.getUserLoginValidations(),
            ...this.getUserValidations(),
            ...this.getAddressValidations(),
        });
    },
    methods: {
        ...mapActions(['setFlashMessage']),
        uploadImages() {
            const imagePromises = this.images.map((image) => image.promise);
            return new Promise((resolve) => {
                Promise.all(imagePromises).then((images) => {
                    if (!images.length || !images[0]) {
                        resolve([]);
                        return;
                    }
                    // Images have already been processed
                    if (images[0].id) {
                        resolve(images.map((image) => image.id));
                        return;
                    }
                    fileUploadService(images, this.$axios, this.$config, this.$sentry).then((data) => {
                        resolve(data.map((image) => image.id));
                    });
                });
            });
        },
        async submitMobileNumber() {
            if (this.mobile_number) {
                await this.$axios.$put(this.$config.endpoints.user, {
                    mobile_number: this.mobile_number,
                });
                await this.$auth.fetchUser();
            }
        },
        async createJob() {
            this.$clearwaste.$loading.start();
            await this.submitAddress();
            if (!this.address?.id) {
                this.$clearwaste.$loading.finish();
                return;
            }
            await this.submitMobileNumber();
            const images = await this.uploadImages();
            const { data } = await this.$form.submit(this.$config.endpoints.job, 'post', {
                access_information: this.accessInformation,
                ...(this.address && { address_id: this.address.id }),
                ...(this.address && { lat: this.address.lat }),
                ...(this.address && { lon: this.address.lon }),
                categories: this.categories,
                description: this.description,
                service_id: this.services,
                size: this.size,
                images,
                ...(this.$form.enumDate.$model !== 'specific' && { preferred_collection: this.$form.enumDate.$model }),
                ...(this.$form.enumDate.$model === 'specific' && { preferred_date: this.date }),
                private_land: this.landType,
            });
            this.$router.push({ name: 'jobs-id', params: { id: data.job.id } });
            this.setFlashMessage({ message: data.message });
        },
    },
};
